import React, { Component } from 'react';
import { Row, Col } from 'bootstrap-4-react';
import '../../styles/css/DashboardComponents/UserStats.css';
import { Doughnut } from 'react-chartjs-2';

class UserStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chart: {
                data: {
                    labels: ['Admins', 'Title companies', 'Title company users', 'Surveyors'],
                    datasets: [{
                        data: [0, 0, 0, 0],
                        backgroundColor: ['#019ae3', '#e34c01', '#e3bd01', '#9801e3']
                    }]
                }
                ,
                height: 150,
                options: {
                    maintainAspectRatio: true,
                    cutoutPercentage: 60,
                    responsive: true,
                    legend: {
                        display: false,
                        position: 'bottom',
                        align: 'center',
                    }
                }
            }
        }
    }

    componentDidMount() {
        
        this.setState({
            chart: {
                data: {
                    labels: ['Admins', 'Title companies', 'Title company users', 'Surveyors'],
                    datasets: [{
                        data: [this.props.usersData.admins, this.props.usersData.title_admins, this.props.usersData.title_users, this.props.usersData.surveyors],
                        backgroundColor: ['#019ae3', '#e34c01', '#e3bd01', '#9801e3']
                    }]
                }
                ,
                height: 150,
                options: {
                    maintainAspectRatio: true,
                    cutoutPercentage: 60,
                    responsive: true,
                    legend: {
                        display: false,
                        position: 'bottom',
                        align: 'center',
                    }
                }
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.usersData !== prevProps.usersData) {
            this.setState({
                chart: {
                    data: {
                        labels: ['Admins', 'Title companies', 'Title company users', 'Surveyors'],
                        datasets: [{
                            data: [this.props.usersData.admins, this.props.usersData.title_admins, this.props.usersData.title_users, this.props.usersData.surveyors],
                            backgroundColor: ['#019ae3', '#e34c01', '#e3bd01', '#9801e3']
                        }]
                    }
                    ,
                    height: 150,
                    options: {
                        maintainAspectRatio: true,
                        cutoutPercentage: 60,
                        responsive: true,
                        legend: {
                            display: false,
                            position: 'bottom',
                            align: 'center',
                        }
                    }
                }
            })
        }
    }

    render() {

        const { chart } = this.state;
        const { usersData } = this.props;

        return (
            <div className="headerCardRoot">
                <div className="adminHeaderCardMain">
                    <div className="userHeaderCardTitle">
                        <span>User statistics</span>
                    </div>
                    <div className="adminHeaderCardBody">
                        <Row>
                            <Col col="sm-12 md-12 lg-6">
                                <Doughnut
                                    data={chart.data}
                                    height={chart.height}
                                    options={chart.options}
                                />
                            </Col>
                            <Col col="sm-12 md-12 lg-6">
                                <div className="totalUserStats">
                                    <div className="statRow highlighted">
                                        <span>Total active users</span>
                                        <span className="paddingRight">{usersData.all_users}</span>
                                    </div>
                                    <div className="statRow">
                                        <div className="statSubRow">
                                            <span>Admins</span>
                                            <span className="legendColor-Admin"></span>
                                        </div>
                                        <span className="paddingRight">{usersData.admins}</span>
                                    </div>
                                    <div className="statRow">
                                        <div className="statSubRow">
                                            <span>Title companies</span>
                                            <span className="legendColor-TC"></span>
                                        </div>
                                        <span className="paddingRight">{usersData.title_admins}</span>
                                    </div>
                                    <div className="statRow">
                                        <div className="statSubRow">
                                            <span>Title company users</span>
                                            <span className="legendColor-CU"></span>
                                        </div>
                                        <span className="paddingRight">{usersData.title_users}</span>
                                    </div>
                                    <div className="statRow">
                                        <div className="statSubRow">
                                            <span>Surveyors</span>
                                            <span className="legendColor-Surveyor"></span>
                                        </div>
                                        <span className="paddingRight">{usersData.surveyors}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserStats;


// WEBPACK FOOTER //
// ./src/components/DashboardComponents/UserStats.js